'use strict';

import('./js/favorites.js');
import('./js/mobile_menu.js');
import('./js/rating_modal.js');
import('./js/scroll_up.js');
import('./js/quote-favorites.js');
import('./js/header.js');
import('./js/favorite_modal.js');
